import { MoneyBox } from '@apply/components';
import { useCustomPaymentAmount } from '../../../../../fields/CustomPaymentFields';

interface PaymentAmountProps {
    customPaymentId: string;
}

export const PaymentAmount: React.FC<PaymentAmountProps> = ({ customPaymentId }) => {
    const [paymentAmount, set_paymentAmount] = useCustomPaymentAmount(customPaymentId);
    const label = 'Payment Amount ';
    return (
        <>
            <MoneyBox
                id='paymentAmount'
                allowNegative={false}
                value={paymentAmount}
                onChange={(value) => {
                    set_paymentAmount(value || 0);
                }}
                required={true}
                label={label}
                displayChange={true}
            />
        </>
    );
};
